import { render } from "./loading.vue?vue&type=template&id=e6df3608&scoped=true&ts=true"
import script from "./loading.vue?vue&type=script&lang=ts"
export * from "./loading.vue?vue&type=script&lang=ts"

import "./loading.vue?vue&type=style&index=0&id=e6df3608&scoped=true&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6df3608"]])

export default __exports__